function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 76 75"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: ".18",
  width: "75",
  height: "75",
  rx: "28",
  fill: "#FFD300"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.377 43.64c0-2.865 1.173-5.6 2.997-7.555h-9.51c1.824 1.954 2.996 4.69 2.996 7.556 0 5.471-4.038 10.161-9.38 10.943v3.647h22.147v-3.647c-5.211-.782-9.25-5.342-9.25-10.943z",
  fill: "#FDFF9F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.925 31.917H22.31c-2.605 0-4.82-2.215-4.82-4.82 0-2.606 2.085-4.82 4.82-4.82h30.745c2.605 0 4.82 2.214 4.82 4.82 0 2.605-2.215 4.82-4.95 4.82z",
  stroke: "#FDFF9F",
  strokeWidth: "1.637"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.612 58.364H51.75c.39 0 .781-.391.781-.782v-2.996c0-.391-.39-.782-.781-.782H23.61c-.39 0-.78.39-.78.782v2.996c0 .39.39.782.78.782zM48.496 16.154H23.223v10.812c0 4.039 1.433 7.947 3.778 10.813 2.345 2.736 5.471 4.69 9.119 5.08 8.598.913 15.893-6.383 15.893-15.502V16.154h-3.517z",
  fill: "#FDFF9F"
}));